import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

const ScrambleText = ({ text }) => {
  const [displayText, setDisplayText] = useState(text);
  const originalTextRef = useRef(text);
  const isAnimatingRef = useRef(false);

  useEffect(() => {
    originalTextRef.current = text;
    setDisplayText(text);
    isAnimatingRef.current = false;
  }, [text]);

  const handleScramble = () => {
    if (isAnimatingRef.current) return;

    isAnimatingRef.current = true;
    const original = originalTextRef.current;
    const textLength = original.length;
    const scrambleIntervalDelay = 200;
    const letterStaggerDelay = 50;

    for (let i = 0; i < textLength; i += 1) {
      setTimeout(() => {
        let count = 0;
        const maxCount = 10;

        const interval = setInterval(() => {
          const randomChar = alphabet[Math.floor(Math.random() * alphabet.length)];
          setDisplayText((prev) => {
            const chars = prev.split('');
            chars[i] = randomChar;
            return chars.join('');
          });

          count += 1;
          if (count >= maxCount) {
            clearInterval(interval);
            setDisplayText((prev) => {
              const chars = prev.split('');
              chars[i] = original[i];
              return chars.join('');
            });

            if (i === textLength - 1) {
              setTimeout(() => {
                isAnimatingRef.current = false;
              }, letterStaggerDelay);
            }
          }
        }, scrambleIntervalDelay);
      }, i * letterStaggerDelay);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleScramble();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <span>
      {/* // onMouseOver={handleScramble}
      // onFocus={handleScramble}
      // style={{ cursor: 'pointer', outline: 'none' }} */}
      {displayText}
    </span>
  );
};

ScrambleText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ScrambleText;
